module.exports = __webpack_public_path__ + "media/quack.f482009d.wav";